export default __webpack_public_path__ + "static/Dave-thompson--450x520-edd29ea34bc5e5f6ee77f7e961549310.jpg";